// extracted by mini-css-extract-plugin
module.exports = {"root":"WeightInput_root__22yMI","hasError":"WeightInput_hasError__1Szg3"};